import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'

export const config = {
  rowSelection: true,
  columns: [
    {
      title: '组合SPU名称',
      dataIndex: 'mainProductName',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '组合SPU_ID',
      dataIndex: 'mainProductId',
      width: 200,
    },
    {
      title: '组合SPU状态',
      dataIndex: 'mainProductEnabled',
      width: 120,
      render: 'enabledRender'
    },
    {
      title: '组合特项代码',
      dataIndex: 'mainProductSpecialCode',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '子产品SPU名称',
      dataIndex: 'prodName',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: (
        <span>
          附图顺序
          <Tooltip title="通过填写数字指定子产品SPU图片附图给组合SPU图片的顺序，空则代表不附给组合">
            <QuestionCircleOutlined style={{ marginLeft: 4}} />
          </Tooltip>
        </span>
      ),
      dataIndex: 'picSort',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '子产品SPU_ID',
      dataIndex: 'productId',
      width: 180,
    },
    {
      title: '子产品来源',
      dataIndex: 'productSourceName',
      width: 160,
    },
    {
      title: '单位',
      dataIndex: ['unitInfo', 'unitName'],
      width: 120,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '数量',
      dataIndex: 'size',
      width: 120,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '是否可查看',
      dataIndex: 'allowView',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
      render: v => (v ? '是' : '否'),
    },
    {
      title: '是否必选',
      dataIndex: 'required',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
      render: v => (v ? '是' : '否'),
    },
    {
      title: '是否参与计算',
      dataIndex: 'allowCalculation',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
      render: v => (v ? '是' : '否'),
    },
    {
      title: '是否发包',
      dataIndex: 'allowSendPack',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
      render: v => (v ? '是' : '否'),
    },
    {
      title: '开始日期',
      dataIndex: 'startDate',
      width: 160,
      itemType: 'date',
    },
    {
      title: '结束日期',
      dataIndex: 'endDate',
      width: 160,
      itemType: 'date',
    },
    {
      title: 'SPU适用门店',
      dataIndex: 'applyProductShopList',
      width: 200,
      render: 'shopNameRender',
      ellipsis: true,
    },
    {
      title: '创建人',
      dataIndex: 'createdByName',
      width: 120,
    },
    {
      title: '创建时间',
      dataIndex: 'createdTime',
      itemType: 'dateTime',
      width: 200,
    },
    {
      title: '子产品SPU状态',
      dataIndex: 'spuEnabled',
      width: 140,
      render: 'enabledRender',
      fixed: 'right',
    },
    {
      title: 'SKU包含类型',
      dataIndex: 'selectTypeName',
      width: 140,
      fixed: 'right',
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 200,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'mainProductKeyword',
      label: '组合SPU名称/ID',
    },
    {
      name: 'mainProductSkuKeyWord',
      label: '组合SKU名称/ID',
    },
    {
      name: 'productKeyword',
      label: '子产品SPU名称/ID',
    },
    {
      name: 'productSkuKeyWord',
      label: '子产品SKU_ID',
    },
    {
      name: 'currentDate',
      itemType: 'date',
      label: '日期',
    },
    {
      name: 'mainProductSpecialCode',
      label: '组合特项代码',
      itemType: 'select',
      data: 'specialCodeList',
      labelKey: 'label',
      key: 'value',
    },
    {
      name: 'mainProductEnabled',
      label: '组合SPU状态',
      itemType: 'select',
      data: 'enabledList',
      labelKey: 'label',
      key: 'value',
    },
    {
      label: '子产品来源',
      name: 'productSourceType',
      itemType: 'select',
      data: 'sourceTypeList',
      labelKey: 'description',
      key: 'key',
    },
  ],
  footer: [
    {
      label: '列表数据全选',
      events: ['onClick:allSelect'],
    },
    { label: '下载模板', render: 'exportRender' },
    { label: '导入产品', render: 'importRender' },
    { label: '导出', render: 'exportRenderData' },
  ],
  batchActions: [
    {
      label: '批量删除',
      // auth: 'priceButton4',
      danger: true,
      ghost: true,
      events: ['onClick:onMultipleDelete'],
      status: ['disabled:delBtnDisabled']
    },
    {
      label: '开始日期',
      // auth: 'priceButton4',
      danger: true,
      ghost: true,
      events: ['onClick:onBatchChangeStartTime'],
    },
    {
      label: '结束日期',
      // auth: 'priceButton4',
      danger: true,
      ghost: true,
      events: ['onClick:onBatchChangeEndTime'],
    },
    {
      label: '添加子产品',
      // auth: 'priceButton4',
      danger: true,
      ghost: true,
      events: ['onClick:onBatchAddSubProduct'],
    },
  ],
}
